export const MAIN_RESET_PASSWORD_TEST_IDS = {
  // ─── Reset Password Page ───
  pageContainer: 'main-reset-password-page-container',
  heading: 'main-reset-password-heading',
  description: 'main-reset-password-description',

  // ─── Reset Password Form ───
  form: 'main-reset-password-form',
  emailInput: 'main-reset-password-email-input',
  emailErrorMessage: 'main-reset-password-email-error',
  recaptcha: 'main-reset-password-recaptcha',
  captchaErrorMessage: 'main-reset-password-captcha-error',
  resetFailedMessage: 'main-reset-password-failed-message',
  cancelButton: 'main-reset-password-cancel-btn',
  continueButton: 'main-reset-password-continue-btn',

  // ─── Success State ───
  successHeading: 'main-reset-password-success-heading',
  successDescription: 'main-reset-password-success-description',
  successGoHomeButton: 'main-reset-password-success-go-home-btn',
} as const;
